import gsap, { Power4 } from 'gsap';
import axios from 'axios';
import Scroller from '@/plugins/scroller';

class Step {
    private el: HTMLElement;
    private index: number;
    private isOpen: boolean;
    private scroller: any;

    constructor(el: any, isOpen: boolean = false) {
        this.el = el;
        this.index = Number(this.el.getAttribute('data-step'));
        this.isOpen = isOpen;
        this.scroller = new Scroller();
        this.init();
    }

    private init() {
        if (this.isOpen) {
            this.open();
        } else {
            this.close();
        }
        (this as any).el.getStep = this;
    }

    private open() {
        this.el.classList.add('open');
        gsap.to(this.el, .7, {
            height: 'auto', backgroundColor: '#FFF', ease: Power4.easeInOut, onComplete: () => {
                this.scroller.scrollTo(`[data-step="${this.index}"]`, null, -50);
            },
        });
    }

    private close() {
        this.el.classList.remove('open');
        gsap.to(this.el, .7, { height: 64, backgroundColor: '#d6d6d6', ease: Power4.easeInOut });
    }
}

class AccordionWizard {
    private el: HTMLElement;
    private steps: any[];
    private currentStep: number = 0;
    private buttons: any[];
    private inputs: any[];
    private inputsList: any[];
    private form: any;
    private loader: any;
    private observer: any;
    private action: any = 'register';
    private flashMessage: any = null;

    constructor(el: HTMLElement) {
        this.el = el;
        this.form = this.el.querySelector('form');
        this.steps = Array.from(this.el.querySelectorAll('[data-step]'));
        this.buttons = Array.from(this.el.querySelectorAll('[data-step-action]'));
        this.inputs = Array.from(
            this.el.querySelectorAll(
                'input[required]:not([type="hidden"]):not([type="radio"]), select[required], textarea[required]',
            ),
        );
        this.inputsList = Array.from(this.el.querySelectorAll('[data-list-group]'));
        this.loader = document.querySelector('[data-loader]');
        this.flashMessage = this.el.querySelector('.flashMessage');

        this.setStep();

        this.addEvents();

        this.init();
    }

    private setStep() {
        Array.from(this.steps).forEach((element, index) => {
            new Step(element, index === this.currentStep);
        });
    }

    private addEvents() {
        let observable = document.querySelector('[data-authentication]');
        this.buttons.forEach((button: any) => {
            const type = button.getAttribute('data-step-action');
            button.addEventListener('click', (e: any) => {
                switch (type) {
                    case 'next':
                        e.preventDefault();
                        this.openNext();
                        break;

                    case 'prev':
                        e.preventDefault();
                        this.openPrev();
                        break;

                    case 'submit':
                        this.onSubmit(e);
                        break;
                    case 'submitAndRegister':
                        this.onSubmitAndRegister(e);
                        break;
                    default:
                        e.preventDefault();
                }
            });
        });

        if (observable) {
            this.observer = new MutationObserver((mutationList, observer) => {
                mutationList.forEach((mutation) => {
                    Array.from(mutation.addedNodes).filter((el: any) => el.hasAttribute).forEach((el: any) => {
                        if (el.hasAttribute('data-ajax-login')) {
                            this.action = 'login';
                        } else {
                            this.action = 'register';
                        }
                    })
                });
            });

            this.observer.observe(observable, { childList: true });
        }


        this.handleForceValidation();
    }

    private goToStep(index: number) {
        const current = this.steps.find(
            (step: any) =>
                Number(step.getAttribute('data-step')) === this.currentStep,
        );
        const next = this.steps.find(
            (step: any) => Number(step.getAttribute('data-step')) === index,
        );

        current.getStep.close();
        next.getStep.open();
        this.currentStep = index;
    }

    private openNext() {
        const current = this.steps.find(
            (step: any) =>
                Number(step.getAttribute('data-step')) === this.currentStep,
        );
        const next = this.steps.find(
            (step: any) =>
                Number(step.getAttribute('data-step')) === this.currentStep + 1,
        );

        current.getStep.close();
        next.getStep.open();
        this.currentStep += 1;
    }

    private openPrev() {
        const current = this.steps.find(
            (step: any) =>
                Number(step.getAttribute('data-step')) === this.currentStep,
        );
        const prev = this.steps.find(
            (step: any) =>
                Number(step.getAttribute('data-step')) === this.currentStep - 1,
        );

        current.getStep.close();
        prev.getStep.open();
        this.currentStep -= 1;
    }

    private onSubmit(e: any) {
        this.resetInputs();
        this.resetInputList();

        let clientIdInput: any = this.el.querySelector('input[name="clientId"]');
        // let pageNameInput: any = this.el.querySelector('input[name="pageName"]');

        let errors = 0;
        let closestStep = this.inputs.find((input: any) => !input.validity.valid)?.closest('[data-step]');

        this.inputs.forEach((input: any) => {
            errors += this.checkValidity(input);
        });

        this.inputsList.forEach((inputList) => {
            errors += this.checkListValidity(inputList);
        });

        if ((window as any).gaGlobal && (window as any).gaGlobal.vid && clientIdInput) {
            clientIdInput.value = (window as any).gaGlobal.vid
        }

        // if (pageName && pageNameInput) {
        //     pageNameInput.value = pageName;
        // }

        if (errors) {
            e.preventDefault()
            console.log(`Form has ${errors} errors`)
            if (closestStep) {
                this.goToStep(Number(closestStep.dataset.step));
            }
        } else {
            this.submitForm(e);
        }
    }

    private onSubmitAndRegister(e: any) {
        let input = this.form.querySelector('[data-subscribe-input]');

        if (input) {
            input.value = 1;
        }

        this.onSubmit(e);
    }

    private submitForm(e: any) {
        const submitBtn = document.getElementById('accordeon_submit')
        if(!submitBtn) {
            console.error('accordeon_submit wasn\'t found')
            alert('Can\'t submit form')
            return
        }

        this.setLoading(true);
        if (this.action === 'register') {
            console.log('Default submit action')
            return //let the default submit action operate
        } else {
            e.preventDefault()

            let el: any = this.el.querySelector('[data-ajax-login]');
            let email: any = el.querySelector('input[type="email"]');
            let password: any = el.querySelector('input[type="password"]');
            return axios.post(el.dataset.ajaxLogin, {
                username: email?.value,
                password: password?.value,
            }).then((data: any) => {
                this.form.submit();
            }).catch((err) => {
                if (this.flashMessage) {
                    this.displayFlashMessage(err.response.data.error);
                    this.setLoading(false);
                }
            })
        }
    }

    private displayFlashMessage(message: string = '') {
        let fContent: any = this.flashMessage.querySelector('[data-content]');
        if (fContent) {
            fContent.innerHTML = message;
            this.flashMessage.classList.add('visible');
        }
    }

    private setLoading(isLoading: boolean = true) {
        if (isLoading) {
            this.form.classList.add('loading');
            this.loader.classList.remove('hidden');
        } else {
            this.form.classList.remove('loading');
            this.loader.classList.add('hidden');
        }
    }

    private resetInputs() {
        this.inputs = Array.from(
            this.el.querySelectorAll(
                'input[required]:not([type="hidden"]):not([type="radio"]), select[required], textarea[required]',
            ),
        );
    }

    private resetInputList() {
        this.inputsList = Array.from(this.el.querySelectorAll('[data-list-group]'));
    }

    private handleError(element: any, isList: boolean = false) {
        let formGroup: any = element.closest('.form-group');
        let formError: any = formGroup.querySelector('.form-errors');
        let inputValidationEventType = element.hasAttribute('data-validation-event-type') ? element.dataset.validationEventType : 'input';
        let message: any = '';

        if (!element.hasValidationEvent) {
            if (!isList) {
                element.addEventListener(inputValidationEventType, () => {
                    this.checkValidity(element, false);
                });
            } else {
                Array.from(element.querySelectorAll('input')).forEach((input: any) => {
                    input.addEventListener(inputValidationEventType, () => {
                        this.checkListValidity(element);
                    })
                })
            }

            element.hasValidationEvent = true;
        }

        message = element.dataset.errorMessage ? element.dataset.errorMessage : element.validationMessage;
        console.log(`Form error: ${message}`)
        if (!formError) {
            formGroup.insertAdjacentHTML(
                'beforeend',
                `<ul class="form-errors">
          <li>${message}</li>
        </ul>`,
            );
        } else {
            formError.innerHTML = `<li>${message}</li>`
        }

        formGroup.classList.add('field-error');
    }

    private handleSuccess(input: any, isList: boolean = false) {
        let formGroup: any = input.closest('.form-group');
        let formError: any = formGroup.querySelector('.form-errors');

        formGroup.classList.remove('field-error');
        if (formError) {
            formError.remove();
        }
    }

    private checkValidity(input: any, isList: boolean = false) {
        if (!input.validity.valid) {
            this.handleError(input);
            return 1;
        } else {
            this.handleSuccess(input);
            return 0;
        }
    }

    private checkListValidity(inputList: any) {
        let error = 0;
        let inputs = Array.from(inputList.querySelectorAll('input'));

        if (!inputs.some((input: any) => input.checked)) {
            error = 1;
            this.handleError(inputList, true);
        } else {
            this.handleSuccess(inputList, true);
        }

        return error;
    }

    private handleForceValidation() {
        let fields: any = Array.from(
            this.form.querySelectorAll('[data-force-validation]'),
        );
        fields.forEach((field: any) => {
            if (
                !field.hasForceValidationEvent &&
                field.dataset.forceValidation === 'phone'
            ) {
                field.addEventListener('input', () => {
                    if (field.value.length > 0) {
                        field.setAttribute('required', 'required');
                    } else {
                        field.removeAttribute('required');
                        this.handleSuccess(field);
                    }
                });
                field.hasForceValidationEvent = true;
            }
        });
    }

    private init() {
        (this as any).el.getAccordionWizard = this;
    }
}

export default AccordionWizard;
